import React, { useState, useEffect } from 'react';
import { updatePermissionForm } from '../../lib/actions';
import { useNavigate } from 'react-router-dom';
import { ThreeDot } from 'react-loading-indicators';
import { useTranslation } from 'react-i18next';

export default function GetEditPermissions({ permissionId, permissionsData }) {
  const nav = useNavigate();
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = i18n.t.bind(i18n); 

  useEffect(() => {
    setPermissions(permissionsData);
  }, [permissionsData]);

  const togglePermission = (id) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((permission) =>
        permission.id === id ? { ...permission, status: !permission.status } : permission
      )
    );
  };

  const navigate = (route) => {
    nav(route);
  };

  const handleSave = async () => {
    setLoading(true);
    const activeIds = permissions.filter((permission) => permission.status).map((permission) => permission.id);
    const formData = new FormData();
    activeIds.forEach(id => {
      formData.append('permission_ids[]', id);
    });
    await updatePermissionForm(permissionId, formData, navigate);
    setLoading(false);
  };

  if (((permissionId).length < 1) || (permissionsData.length < 1)) {
    return (
      <div className="flex justify-center items-center h-[25rem]">
        <ThreeDot variant="bounce" color="#D06421" size="large" />
      </div>
    );
  }

  return (
    <div className="p-4 flex flex-col justify-center items-center">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {permissions.map((permission) => (
          <div key={permission.id} className="flex items-center space-x-3">
            {/* ✅ Custom Toggle Switch */}
            <div
              onClick={() => togglePermission(permission.id)}
              className={`relative w-12 h-6 flex items-center rounded-full cursor-pointer transition-colors duration-300 ${
                permission.status ? 'bg-green-500' : 'bg-gray-400'
              }`}
            >
              <div
                className={`w-6 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                  permission.status ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-5') : (currentLang === 'ar' ? '-translate-x-5' : 'translate-x-1')
                }`}
              ></div>
            </div>

            <label
              htmlFor={`permission-${permission.id}`}
              className="text-white font-medium ps-2 hover:text-gray-200 transition-colors cursor-pointer select-none"
              onClick={() => togglePermission(permission.id)}
            >
              {permission.guard_name}
            </label>
          </div>
        ))}
      </div>

      <div className="flex justify-center w-full mt-10">
        <button
          onClick={handleSave}
          disabled={loading}
          className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${
            loading ? 'cursor-not-allowed' : 'hover:bg-primary'
          }`}
        >
          {loading ? (
            <svg
              className="animate-spin h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              ></path>
            </svg>
          ) : (
            currentLang === "en" ? "Save" : "حفظ"
          )}
        </button>
      </div>
    </div>
  );
}
